import { defineWebformElementMapper } from '../defineWebformElementMapper'

export default defineWebformElementMapper(['WebformElementDate'], (item) => {
  return {
    $formkit: 'date',
    min: item.element.dateDateMin,
    max: item.element.dateDateMax,
  }
})
